import { DatePicker } from 'antd';
import { ICellRendererParams } from 'ag-grid-community';
import CalendarIcon from 'assets/icons/calendar';
import { Dayjs } from 'dayjs';
import { useCallback } from 'react';

interface AgGridDatePickerProps extends ICellRendererParams {
  value: Dayjs;
  disabledDate?: (current: Dayjs) => boolean;
  disabled?: boolean;
}

const AgGridDatePicker = (props: AgGridDatePickerProps) => {
  const { value, node, column, disabledDate, disabled } = props;

  const handleChange = useCallback(
    (date: Dayjs | null) => {
      if (column) {
        node.setDataValue(column.getColId(), date);
      }
    },
    [column, node]
  );

  return (
    <DatePicker
      value={value}
      onChange={handleChange}
      format="DD/MM/YYYY"
      className="w-full"
      suffixIcon={<CalendarIcon />}
      allowClear={false}
      variant="borderless"
      disabledDate={disabledDate}
      disabled={disabled}
    />
  );
};

export default AgGridDatePicker;
